import { render, staticRenderFns } from "./Ornament.vue?vue&type=template&id=7b531aba&scoped=true&"
import script from "./Ornament.vue?vue&type=script&lang=js&"
export * from "./Ornament.vue?vue&type=script&lang=js&"
import style0 from "./Ornament.vue?vue&type=style&index=0&id=7b531aba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b531aba",
  null
  
)

export default component.exports